module.exports = __webpack_public_path__ + "static/media/eht-campaign.5e59520b.png";